import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#F5EDE0] text-gray-800 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <img 
                src="/marketry-logo.png" 
                alt="MARKETRY - Build for adaptation" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-700 leading-relaxed max-w-md">
              Fresh insights from marketing students, backed by research. 
              Guiding brands and students through every touchpoint in the Australian market.
            </p>
            <div className="flex gap-4 mt-6">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#A0704E] hover:bg-[#8B5F3E] rounded-full flex items-center justify-center transition-colors text-white"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#A0704E] hover:bg-[#8B5F3E] rounded-full flex items-center justify-center transition-colors text-white"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-gray-900">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-700 hover:text-[#A0704E] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/reports" className="text-gray-700 hover:text-[#A0704E] transition-colors">
                  Reports
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-700 hover:text-[#A0704E] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-700 hover:text-[#A0704E] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-gray-900">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/reports" className="text-gray-700 hover:text-[#A0704E] transition-colors">
                  Industry Reports
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-700 hover:text-[#A0704E] transition-colors">
                  For Students
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-700 hover:text-[#A0704E] transition-colors">
                  For Businesses
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-700 hover:text-[#A0704E] transition-colors">
                  Get Consultation
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-300 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm">
              © {currentYear} Marketry. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-600 hover:text-[#A0704E] transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-600 hover:text-[#A0704E] transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
